import { createSelector, createReducer } from '@reduxjs/toolkit';

import {
  selectAllFromApiState,
  getIncludedData,
} from '../helpers/selectorHelpers';
import { FIELD_INCLUDE, FIELD_TYPE } from '../../constants/api';
import { updateDtoList } from '../helpers/reducerHelpers';
import { hearingTemplateByHearingTypeIdSelector } from './hearingTemplateSlice';
import { getRelId, getEntityId, getAttr } from '../helpers/apiHelpers';
import {
  getAllHearingsSuccess,
  getAllHearingTemplatesSuccess,
  getAllHearingTypesSuccess,
  getHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';

// -------- Overview --------

// Field is included in the following endpoints
//  - GET /hearingType/{hearingTypeId}/fieldTemplate
//  - GET /hearingType
//  - GET /hearing
//  - GET /hearing/{hearingId}

// -------- Reducer --------
const fieldReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingTypesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fields = data.filter((include) => include.type === FIELD_INCLUDE);
        return updateDtoList(state, 'all', fields);
      })
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fields = data.filter((include) => include.type === FIELD_INCLUDE);
        return updateDtoList(state, 'all', fields);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fields = data.filter((include) => include.type === FIELD_INCLUDE);
        return updateDtoList(state, 'all', fields);
      })
      .addCase(getAllHearingTemplatesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fields = data.filter((include) => include.type === FIELD_TYPE);
        return updateDtoList(state, 'all', fields);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fields = data.filter((include) => include.type === FIELD_INCLUDE);
        return updateDtoList(state, 'all', fields);
      });
  },
);

// -------- Selectors --------
const selectGetAllFields = (state) => selectAllFromApiState(state, 'field');
const allFieldsSelector = createSelector(
  selectGetAllFields,
  (fields) => fields,
);
const allFieldsByHearingTypeIdSelector = (hearingTypeId) =>
  createSelector(
    [allFieldsSelector, hearingTemplateByHearingTypeIdSelector(hearingTypeId)],
    (fields, hearingTemplate) =>
      fields.filter(
        (f) => getRelId(f, 'hearingTemplate') === getEntityId(hearingTemplate),
      ),
  );

const allFieldsAllowingFieldTemplatesSelector = createSelector(
  [allFieldsSelector],
  (fields) => fields.filter((f) => !!getAttr(f, 'allowTemplates')),
);
const fieldByIdSelector = (id) =>
  createSelector([allFieldsSelector], (fields) =>
    fields.find((f) => getEntityId(f) === id),
  );

// -------- Exporting --------
export {
  allFieldsSelector,
  allFieldsByHearingTypeIdSelector,
  allFieldsAllowingFieldTemplatesSelector,
  fieldByIdSelector,
};
export default fieldReducer;
